var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getMarketId, getBetSlipOdds, getSelectionSide, getMarketTypeId, isMarketQA, getMarketEventID } from "../helpers";
import { BsUtilEmptySelection, BsUtilEmptyMarket } from "../constants";
var Parser = /** @class */ (function () {
    function Parser() {
    }
    Parser.prototype.getLegacySelectionData = function (event, market, selection) {
        var m = __assign({}, BsUtilEmptyMarket, market);
        var s = __assign({}, BsUtilEmptySelection, selection);
        return {
            masterEventID: parseInt(getMarketEventID(event, m)),
            eventID: parseInt(getMarketId(m)),
            lineID: parseInt(s.metadata.idSBTech),
            odds: parseInt(getBetSlipOdds(s.displayOdds)),
            lineGroupID: s.group,
            lineTypeID: parseInt(s.metadata.type),
            rowTypeID: getSelectionSide(s),
            points: s.points,
            isLive: m.isLive,
            isQA: isMarketQA(m),
            eventTypeId: parseInt(getMarketTypeId(m)),
            leagueId: parseInt(m.leagueId),
            betId: 0,
            preventUpdating: false,
            isFavedTeam: false
        };
    };
    return Parser;
}());
export { Parser };
//# sourceMappingURL=parser.js.map